import { render, staticRenderFns } from "./StyleDetailsNew.vue?vue&type=template&id=f2fa9e06&scoped=true"
import script from "./StyleDetailsNew.vue?vue&type=script&lang=js"
export * from "./StyleDetailsNew.vue?vue&type=script&lang=js"
import style0 from "./StyleDetailsNew.vue?vue&type=style&index=0&id=f2fa9e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fa9e06",
  null
  
)

export default component.exports